export default "__VITE_ASSET__C8_9eJwn__"